module.exports = __webpack_public_path__ + "img/undraw_development_re_g5hq.54897dd9.svg";